import React from "react";
import { observer } from "mobx-react";
import { withStyles } from "@material-ui/styles";
import { withAlert } from "react-alert";
import Layout from "../../components/Layout";
import MyForm from "./form";

const styles = (theme) => ({
  tableContainer: {
    marginTop: 20,
  },
});

const View = observer(
  class Detail extends React.Component {
    render() {
      const { classes } = this.props;

      return (
        <Layout>
          <MyForm match={this.props.match} {...this.props} />
        </Layout>
      );
    }
  }
);

const alertView = withAlert()(View);
export default withStyles(styles)(alertView);
